import React from "react";
import { useForm, FormProvider } from "react-hook-form";
import { CalendarTimeLabels, CalendarTimeUnit } from "../CalendarEditor";
import ReactTooltip from "react-tooltip";

export function CalendarTimePage({ onSubmit, store, formRef, getCalendar }) {
  const { control, handleSubmit, getValues, ...formMethods } = useForm({
    defaultValues: {
      time: store.time || {},
      // time: getCalendar(store, "form").time || {},
    },
  });
  // const timeUnits = getValues("time");
  const timeUnits = getCalendar(store).time;
  const daysInYear = getCalendar(store).months.reduce((t, m) => {
    return (t += m.days);
  }, 0);
  // console.log("Number of days in year (non-leap)", daysInYear);
  // console.log("Time Units!", timeUnits);
  const tooltipID = "chronosSetupModalTooltip";
  return (
    <div className="chronos-calendar-time-page chronos-calendar-editor">
      <FormProvider
        control={control}
        handleSubmit={handleSubmit}
        getValues={getValues}
        {...formMethods}
      >
        <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
          <h2 className="chronos-wizard-page-title">
            Name and define your time divisions
          </h2>
          <p className="chronos-wizard-text">
            Customize your other time divisions.
          </p>
          <CalendarTimeLabels />
          {Object.keys(timeUnits).map((unit, index) => (
            <CalendarTimeUnit
              unitName={unit}
              key={index}
              dayCount={daysInYear}
              tooltipID={tooltipID}
            />
          ))}
        </form>
        <ReactTooltip id={tooltipID} effect="solid" />
      </FormProvider>
    </div>
  );
}
